import { specicalCssValuePattern, STYLE_FIELDS } from './constant';
import murmurhash from 'murmurhash/murmurhash';
export const getDeltaValue = function (deltaX, deltaY, field) {
  let deltaValue = 0;
  switch (true) {
    case field === 'marginLeft' || field === 'paddingLeft':
      deltaValue = -deltaX;
      break;
    case field === 'marginRight' || field === 'paddingRight':
      deltaValue = deltaX;
      break;
    case field === 'marginTop' || field === 'paddingTop':
      deltaValue = -deltaY;
      break;
    case field === 'marginBottom' || field === 'paddingBottom':
      deltaValue = deltaY;
      break;
  }
  return deltaValue;
};

/**
 * 去掉styleObj中各个字段中的单位
 * @param styleObj 样式对象
 * @returns styleObj（不含单位）
 */

export const trimUnit = function (styleObj = {}) {
  const mpStyleObj = {};
  STYLE_FIELDS.forEach(key => {
    const value = styleObj[key];
    if (value) {
      mpStyleObj[key] = !specicalCssValuePattern.test(value) ? parseInt(value, 10) : value;
    }
  });
  return {
    ...styleObj,
    ...mpStyleObj
  };
};

/**
 * 将rgba颜色值转化为hex
 * @param rgbStr color rgba string
 * @returns {string|*} color hex value
 */
export const rgbaStrToHex = function (rgbStr) {
  if (!rgbStr || rgbStr.length > 20) return '';
  const afterMatch = rgbStr.match(/rgb\(([\S\s]*)\)/);
  if (!afterMatch) return rgbStr;
  const rgbValueArray = afterMatch[1].split(',');
  const r = parseInt(rgbValueArray[0], 10);
  const g = parseInt(rgbValueArray[1], 10);
  const b = parseInt(rgbValueArray[2], 10);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};

/**
 * 将dom.style.boxShadow字符串解析出各个字段
 * @param shadowValue dom.style.boxShadow字符串
 * @returns {{offsetX: number, spreadRadius: number, offsetY: number, color: hex_string, blurRadius: number}}
 */
export const parseBoxShadowStr = function (shadowValue) {
  const rgbRegex = RegExp(/rgb\(([\S\s]*)\)/g);
  const paramRegx = RegExp(/(\s\d*px)/g);
  const rgbaStr = rgbRegex.exec(shadowValue);
  const paramStr = shadowValue.slice(rgbRegex.lastIndex);
  const params = [];
  let param;
  while ((param = paramRegx.exec(paramStr)) !== null) {
    params.push(parseInt(String.prototype.trim.call(param[0]), 10));
  }
  const hexValue = rgbaStrToHex(rgbaStr[0]);
  return {
    offsetX: params[0],
    offsetY: params[1],
    blurRadius: params[2] || 0,
    spreadRadius: params[3] || 0,
    color: hexValue
  };
};
export const camelCaseToCss = function (str) {
  if (typeof str !== 'string') {
    return '';
  }
  return str.replace(/([A-Z])/g, (s, group) => `-${group.toLowerCase()}`);
};
export const cssToCamelCase = function (str) {
  if (typeof str !== 'string') {
    return '';
  }
  return str.replace(/-([a-z])/gi, (s, group) => group.toUpperCase());
};
export function getBase64(img) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      resolve(reader.result);
    });
    reader.readAsDataURL(img);
  });
}
export function getHashValue(value) {
  const hashvalue = murmurhash.v2(value);
  return hashvalue.toString(16);
}
export function getInternalClassNames(value) {
  if (typeof value === 'string') {
    const classNames = value.split(' ');
    return classNames.filter(item => item.indexOf('uc-private') !== -1 || item.indexOf('uc-public') !== -1).join(' ');
  }
}
//# sourceMappingURL=func.js.map
